import { createSlice } from '@reduxjs/toolkit';

type InitialState = {
  isRestrictedAccessModalOpen: boolean;
};

const restrictedAccessSlice = createSlice({
  name: 'restrictedAccess',
  initialState: {
    isRestrictedAccessModalOpen: false,
  } as InitialState,
  reducers: {
    openRestrictedAccessModal: (state) => ({
      ...state,
      isRestrictedAccessModalOpen: true,
    }),
    continueRestrictedAccessModal: (state) => ({
      ...state,
      isRestrictedAccessModalOpen: true,
    }),
    closeRestrictedAccessModal: (state) => ({
      ...state,
      isRestrictedAccessModalOpen: false,
    }),
  },
});

export default restrictedAccessSlice;
